import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  GetCandidatesDocument,
  GetCandidatesQuery,
  GetCandidatesQueryVariables,
} from 'generated/resources/graphql'

export type Candidates = GetCandidatesQuery['ats']['candidates']
type Options = QueryHookOptions<GetCandidatesQuery, GetCandidatesQueryVariables>

export const useCandidates = (options?: Options) => {
  const { data, loading, previousData } = useQuery(GetCandidatesDocument, options)

  return {
    loading,
    candidates: data ? data.ats.candidates : [],
    previousCandidates: previousData ? previousData.ats.candidates : [],
  }
}
